<div class="mid-block-carousel-container">
  <div role="button" class="arrow" [class.disabled]="!isLeftArrowEnabled" (click)="onLeftArrowClick()">
    <i class="fas fa-chevron-left"></i>
  </div>
  <ng-content></ng-content>
  <div role="button" class="arrow" [class.disabled]="!isRightArrowEnabled" (click)="onRightArrowClick()">
    <i class="fas fa-chevron-right"></i>
  </div>
</div>
